module.exports = __webpack_public_path__ + "img/icon.b71d3198.png";